import { ITransferAuthManager } from './transfer-auth-manager.interface';
import ArkLoader from '@src/js/common/ark-extensions';
import transferAuthConfig from '@src/js/common/ark-extensions/dc-components/transfer-auth/component-config';

const containerId = 'transfer-auth-container';

export default class TransferAuthManager implements ITransferAuthManager {
    public showTransferAuth = async (): Promise<void> => {
        const container = this.getContainer();
        container.style.display = 'block';
        const userId = window.clientVars?.userId.replace(/^p\./, '');
        const transferAuthModule = await ArkLoader.extensionService.getExtension(transferAuthConfig.name);
        transferAuthModule?.show({
            container,
            userId,
            weWorkDisabled: true,
            onClose: () => {
                container.style.display = 'none';
            },
        });
    };

    private getContainer = () => {
        let container = document.getElementById(containerId);
        if (!container) {
            container = document.createElement('div');
            container.id = containerId;
        }
        return container;
    };
}
